import { render } from "./ShowProduct.vue?vue&type=template&id=48ed85b6"
import script from "./ShowProduct.vue?vue&type=script&lang=js"
export * from "./ShowProduct.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__